// extracted by mini-css-extract-plugin
export var badgeTextContainer = "_4e-2";
export var blackBorderOnHover = "_4e-7";
export var cell = "_4e-6";
export var cellContainer = "_4e-3";
export var checked = "_4e-8";
export var disabled = "_4e-5";
export var featuredIconCellContainer = "_4e-9";
export var featuredIconTextContainer = "_4e-b";
export var featuredIconWrapper = "_4e-a";
export var noBorder = "_4e-c";
export var orangeSelectedRow = "_c7-3";
export var overflowableText = "_4e-0";
export var overflowableTextContainer = "_4e-1";
export var row = "_4f-0";
export var rowCheckboxCell = "_4e-4";
export var selectableTable = "_c7-2";